import { Card, CardHeader, Table, TableContainer } from "@mui/material";
import Scrollbar from "src/components/Scrollbar";
import useLocales from "src/hooks/useLocales";
import useTable, { getComparator } from "src/hooks/useTable";

import ContextTable from "./contextTable";
import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import useGetEntitiesData from "./useGetEntitiesData";

// ----------------------------------------------------------------------

export const ConnectionsEntitiesPanel = () => {
	const { translate } = useLocales();

	const control = useTable({
		defaultOrderBy: "success",
		defaultOrder: "desc",
		defaultRowsPerPage: 20,
		defaultDense: true
	});

	const data = useGetEntitiesData(getComparator(control.order, control.orderBy));

	return (
		<Card sx={{ pb: 2, height: 502 }}>
			<CardHeader title={translate("overview.total_connections_by_entity")} />
			<ContextTable.Provider value={{ ...control }}>
				<Scrollbar sx={{ height: 434 }}>
					<TableContainer sx={{ mt: 2 }}>
						<Table size='small'>
							<TableHeader />
							<TableBody data={data} />
						</Table>
					</TableContainer>
				</Scrollbar>
			</ContextTable.Provider>
		</Card>
	);
};

export default ConnectionsEntitiesPanel;
